var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "btn btn-secondary sort-button w-full text-left" },
    [
      _vm.filterTemplates
        ? _c("simple-select", {
            attrs: {
              options: _vm.filterTemplatesSelect,
              label: "name",
              placeholder: "Select Filters"
            },
            on: { input: _vm.selected },
            model: {
              value: _vm.filterTemplate,
              callback: function($$v) {
                _vm.filterTemplate = $$v
              },
              expression: "filterTemplate"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d52d4df", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d52d4df","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoadFilterDropdown.vue
// module id = null
// module chunks = 